// extracted by mini-css-extract-plugin
export var button = "_bq-0";
export var icon = "_bq-1";